import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/http";

export type ApiSubscription = {
  status: string;
  end_date: string;
  start_date: string;
  canceled_at: string | null;
};
async function getApiSubscription() {
  return await api.payment.get<ApiSubscription>(
    "v1/api-services/my-subscription",
    {},
  );
}

export const apiSubscriptionQueryOptions = queryOptions({
  queryKey: ["user", "apisubscription"],
  async queryFn() {
    const res = await getApiSubscription();
    const data = await res.json();

    return { res, data };
  },
  select(data) {
    return data.data;
  },
});

export function useApiSubscription() {
  return useQuery(apiSubscriptionQueryOptions);
}
